import Consultations from '@services/Consultations'
import { history as browserHistory } from '@services/History'
import { submissionAttempt, submissionFailure, submissionSuccess } from '../../../../actions/formSubmit'
import { receiveProfessionalShow, receiveProfessionalShowFailure, requestProfessionalShow } from './professionalShow'

/**
 * Thunk to request Professional show.
 *
 * @param  {number} id
 * @return {function(*)}
 */
export function professionalShow(id) {
  return (dispatch) => {
    dispatch(requestProfessionalShow(id))
      .payload.then((result) => {
        dispatch(receiveProfessionalShow(result.data))
      })
      .catch((error) => dispatch(receiveProfessionalShowFailure(error)))
  }
}

/**
 * Thunk to request Professional Schedule.
 *
 * @param  {number} id
 * @param  {object} data
 * @return {function(*)}
 */
export function professionalSchedule(id, data) {
  let { timezone, on_holidays, ...day_schedules } = data
  on_holidays = on_holidays ? 1 : 0
  for (const day in day_schedules) {
    day_schedules[day].active = day_schedules[day].active ? 1 : 0
    day_schedules[day].start_first_period = day_schedules[day].range_1_1
    day_schedules[day].end_first_period = day_schedules[day].range_1_2
    day_schedules[day].start_second_period = day_schedules[day].range_2_1
    day_schedules[day].end_second_period = day_schedules[day].range_2_2
  }

  const request = Consultations.schedules.update(id, { timezone, on_holidays, day_schedules })

  return (dispatch) => {
    dispatch(submissionAttempt(request))
      .payload.then((result) => {
        dispatch(submissionSuccess())
        browserHistory.push('/professional/' + id)
      })
      .catch((error) => dispatch(submissionFailure(error.response.data)))
  }
}

/**
 * Sets the error state to null.
 *
 * @return {object}
 */
export function changeProfessionalErrorToNull() {
  return {
    type: 'PROFESSIONAL_ERROR_NULL',
  }
}
